import _ from 'lodash'

class ChangePaymentDayModalCtrl {
    /** @ngInject */
    constructor(BillingAcc, ErrorCatcher) {
        this.BillingAcc = BillingAcc
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.form = this.resolve.paymentDayInfo
        this.isSubmitting = false
        this.isSubmitted = false
        this.hasError = false
    }

    submitPaymentDay() {
        this.isSubmitting = true
        this.hasError = false
        this.BillingAcc.putPaymentDay({ preferredPaymentDay: this.form.preferredPaymentDay }).$promise.then(() => {
            this.isSubmitting = false
            this.isSubmitted = true
            this.closeModal()
        })
        .catch((error) => {
            this.isSubmitting = false
            this.hasError = true
            this.ErrorCatcher.catchError(error)
        })
    }

    closeModal() {
        this.close({ $value: { isSubmitted: this.isSubmitted } })
    }
}

export default {
    template: require('./changePaymentDayModal.jade')(),
    controller: ChangePaymentDayModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/navbar/modal/changePaymentDayModal.js